import { lazy } from 'react';

import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import AddressVerifiedLayout from 'utils/route-guard/AddressVerifiedLayout';

const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const TicketPage = Loadable(lazy(() => import('views/ticket/TicketPage')));
const RateCalculatorPage = Loadable(lazy(() => import('views/operations/rate-calculator/RateCalculatorPage')));
const GlobalLabelSettings = Loadable(lazy(() => import('views/settings/label-setting/GlobalLabelSettings')));
const LabelSizePage = Loadable(lazy(() => import('views/settings/label-setting/LabelSizePage')));
const CreateOrderPage = Loadable(lazy(() => import('views/orders/create-order/CreateOrderPage')));
const ShipmentPage = Loadable(lazy(() => import('views/shipments/ShipmentPage')));
const ShipmentTrackPage = Loadable(lazy(() => import('views/shipments/ShipmentTrackPage')));
const ShipmentLabelPrintPage = Loadable(lazy(() => import('views/shipments/ShipmentLabelPrintPage')));
const ShipmentTaxInvoicePage = Loadable(lazy(() => import('views/shipments/ShipmentTaxInvoicePage')));
const ShipmentManifestPage = Loadable(lazy(() => import('views/shipments/ShipmentManifestPage')));
const BulkShipmentLabelsPage = Loadable(lazy(() => import('views/shipments/BulkShipmentLabelsPage')));
const NdrPage = Loadable(lazy(() => import('views/ndr/NdrPage')));
const WeightDiscrespencyPage = Loadable(lazy(() => import('views/weight-discrespency')));
const CodManagementPage = Loadable(lazy(() => import('views/cod/CodManagementPage')));
const InvoicePage = Loadable(lazy(() => import('views/invoice/InvoicePage')));
const ReportsPage = Loadable(lazy(() => import('views/reports/ReportsPage')));
const CompleteAddressPage = Loadable(lazy(() => import('views/pages/authentication/CompleteAddressPage')));
const WhatsAppIntegrationPage = Loadable(lazy(() => import('views/whatsapp-integration/WhatsAppIntegrationPage')));
const ConnectStorePage = Loadable(lazy(() => import('views/connect-store/ConnectStorePage')));
const CustomerProfilePage = Loadable(lazy(() => import('views/profile/CustomerProfilePage')));
const Warehouse = Loadable(lazy(() => import('views/warehouse')));
const KYCManagement = Loadable(lazy(() => import('views/customer-kyc/Kyc')));
const BillingPage = Loadable(lazy(() => import('views/billing/BillingPage')));
const OrderListPage = Loadable(lazy(() => import('views/orders/order-list/OrderList')));
const OrderDetailsPage = Loadable(lazy(() => import('views/orders/order-list/OrderDetails')));

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <AddressVerifiedLayout />
    </AuthGuard>
  ),
  children: [
    { path: '/complete-address', element: <CompleteAddressPage /> },
    { path: '/dashboard/default', element: <DashboardDefault /> },
    { path: '/whatsappintegration', element: <WhatsAppIntegrationPage /> },
    { path: '/connect/store', element: <ConnectStorePage /> },
    { path: '/profile', element: <CustomerProfilePage /> },
    { path: '/warehouse', element: <Warehouse /> },
    { path: '/customerkyc', element: <KYCManagement /> },
    { path: '/ticket', element: <TicketPage /> },
    { path: '/shipmentCalculator', element: <RateCalculatorPage /> },
    { path: '/settings/label', element: <GlobalLabelSettings /> },
    { path: '/settings/label/size', element: <LabelSizePage /> },
    { path: '/createOrder', element: <CreateOrderPage /> },
    { path: '/updateOrder/:id', element: <CreateOrderPage /> },
    { path: '/customer/orders', element: <OrderListPage /> },
    { path: '/customer/shipment', element: <ShipmentPage /> },
    { path: '/ndr', element: <NdrPage /> },
    { path: '/weightdiscrepency', element: <WeightDiscrespencyPage /> },
    { path: '/codManagement', element: <CodManagementPage /> },
    { path: '/invoices', element: <InvoicePage /> },
    { path: '/reports', element: <ReportsPage /> },
    { path: '/shipment/order/:id', element: <ShipmentTrackPage /> },
    { path: '/shipment/Invoice/orderPdf/:id', element: <ShipmentLabelPrintPage /> },
    { path: '/shipment/tax-invoice/:id', element: <ShipmentTaxInvoicePage /> },
    { path: '/:id/order/manifest', element: <ShipmentManifestPage /> },
    { path: '/bulkPdf', element: <BulkShipmentLabelsPage /> },
    { path: '/billing', element: <BillingPage /> },
    { path: '/orderDetails/:id', element: <OrderDetailsPage /> }
  ]
};

export default MainRoutes;
